module.exports = __webpack_public_path__ + "static/img/bofang.3d104c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/bofang.png
// module id = beZE
// module chunks = 24